/* jshint esversion: 8 */
/* jshint node: true */

import React, { useEffect, useState } from "react";
import "./LandingPage.scss";
import ProgramResultsFiguresRow from "./ProgramResultsFiguresRow/ProgramResultsFiguresRow";
import Footer from "components/Footer/Footer";
import jsonFooterConfig from "assets/configs/footer-config.json";
import { useSelector } from "react-redux";
import { selectapp } from "stateMgmt/appSlice";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Link from "@mui/material/Link";
import Collapse from "@mui/material/Collapse";
import { isMobileOnly } from "react-device-detect";
import { isPortrait } from "common";
import Typography from "@mui/material/Typography";

const mainContent = (props) => {
  const theme = useSelector(selectapp).theme;
  const appContext = useSelector(selectapp).context;
  const [isHidden, setIsHidden] = useState(false);
  const [open, setOpen] = useState(true);

  let mainContentCssClasses =
    "landing-page__main landing-page__main__left-margin left-margin-wide-monitors";
  if (props.isSidebarCollapsed) {
    mainContentCssClasses = mainContentCssClasses.replace(
      "landing-page__main__left-margin",
      "landing-page__main__closed-margin",
    );
    mainContentCssClasses = mainContentCssClasses.replace(
      "left-margin-wide-monitors",
      "",
    );
  }

  useEffect(() => {
    const hide = appContext !== "home";
    setIsHidden(hide);
    setOpen(isMobileOnly && isPortrait);
  });

  // FORMAT: landing-page__container (HTML)
  return (
    <div
      id="mainContent"
      style={{ backgroundColor: theme.backgroundColor, color: theme.color }}
      className={mainContentCssClasses}
      role="main"
      tabIndex={-1}
    >
      <Collapse in={open}>
        <Alert
          severity="warning"
          sx={{ fontSize: "1.0rem", fontWeight: 800 }}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon sx={{ fontSize: "24px" }} />
            </IconButton>
          }
        >
          This site is best viewed in landscape mode.
        </Alert>
      </Collapse>

      <Typography variant="body1">
        Through the President’s Emergency Plan for AIDS Relief (PEPFAR), the
        U.S. government has made the largest commitment by any nation to address
        a single disease in history - saving 26 million lives, enabling 7.8
        million babies to be born HIV-free, preventing millions of HIV
        infections, and accelerating progress toward controlling the global
        HIV/AIDS pandemic in more than 50 countries.
      </Typography>

      <Typography
        style={{ color: theme.warningColor }}
        tabIndex={0}
        role="note"
      >
        Please note <strong>Data.PEPFAR.Gov</strong> is currently undergoing
        updates and will return soon with refreshed data and interactive
        dashboards. Please view the
        <Link
          variant="body2"
          underline="hover"
          style={{ color: theme.linkColor, fontWeight: 600 }}
          href="/calendar"
          title="Link TO Data Calendar"
          aria-label="Link TO Data Calendar"
        >
          Data Calendar
        </Link>{" "}
        for planned releases, and the
        <Link
          variant="body2"
          underline="hover"
          style={{ color: theme.linkColor, fontWeight: 600 }}
          href="/datasets"
          title="Link TO Datasets"
          aria-label="Link TO Datasets"
        >
          Datasets page
        </Link>{" "}
        for access to PEPFAR data up to FY 2024 (September 30, 2024) and FY 2025
        targets and budgets as approved through congressional notification
        procedures for FY25.
      </Typography>

      <div className="container-fluid landing-page__container">
        <div>
          <ProgramResultsFiguresRow />
        </div>

        <div className="row" id="footer_row_iata">
          <div
            className="col-12"
            style={{
              backgroundColor: theme.backgroundColor,
              color: theme.color,
              fontSize: "1.3vh",
            }}
          >
            <Box
              sx={{ fontSize: "0.6rem" }}
              tabIndex={isHidden ? -1 : 1}
              role="note"
            >
              Unless otherwise noted, the content, data, documentation, code,
              and related materials on data.pepfar.gov is public domain and made
              available with a{" "}
              <a
                href="http://creativecommons.org/publicdomain/zero/1.0/legalcode"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: theme.linkColor }}
                aria-hidden={isHidden}
                tabIndex={isHidden ? "-1" : 1}
              >
                Creative Commons CC0 1.0 Universal
              </a>{" "}
              dedication and license-free (per US Code{" "}
              <a
                href="http://www.gpo.gov/fdsys/pkg/USCODE-2010-title17/html/USCODE-2010-title17-chap1-sec105.htm"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: theme.linkColor }}
                aria-label="Title 17 section 105 subject matter of copyright"
                aria-hidden={isHidden}
                tabIndex={isHidden ? "-1" : 1}
              >
                17 USC § 105
              </a>
              ). Data.pepfar.gov waive all rights to the work worldwide under
              copyright law, including all related and neighboring rights, to
              the extent allowed by law. You can copy, modify, distribute, and
              perform the work, even for commercial purposes, all without asking
              permission. Citation of data.pepfar.gov as a source of the data is
              appreciated.
            </Box>
          </div>
        </div>

        <div>
          <Footer footerConfig={jsonFooterConfig} />
        </div>
      </div>
    </div>
  );
};

export default mainContent;
